module.exports = __webpack_public_path__ + "img/20220112_122025.d779193f.jpg";